export enum LinkedinRelationStatus {
  Connected = 'connected',
  Pending = 'pending',
  NotConnected = 'not-connected',
}